module.exports = __webpack_public_path__ + "img/tully.547cb4d1.png";